import { IBboxSchema } from 'shared/repositories/commercial-listing-map/entities/bbox/BboxSchema';
import { MapBounds } from 'shared/store/clientSide/slices/mapConfiguration/slice';

export const convertMapBoundsToBbox = (bounds: MapBounds): IBboxSchema => {
  const [[latMin, lngMin], [latMax, lngMax]] = bounds;

  return {
    bottomRight: { lat: latMin, lng: lngMax },
    topLeft: { lat: latMax, lng: lngMin },
  };
};
